import { ContentPasteOffSharp } from "@mui/icons-material";
import { createSlice } from "@reduxjs/toolkit";

const roleWiseMenuSlice = createSlice({
  name: "menu",
  initialState: {
    roleWiseData: {
      menus: [],
      permissions: {},
    },
  },
  reducers: {
    setRoleWiseMenu: (state, action) => {
      const { menus, permissions } = action.payload;
      state.roleWiseData = {
        menus,
        permissions,
      };
    },

    clearRoleWiseMenu: (state) => {
      state.roleWiseData = {
        menus: [],
        permissions: {},
      };
    },
  },
});

export const { setRoleWiseMenu, clearRoleWiseMenu } =
  roleWiseMenuSlice.actions;

export default roleWiseMenuSlice.reducer;
